import React, { useState } from 'react'
import styles from './styles.module.css'

function SourceURLs({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  // Toggle expand/collapse state
  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  // Limit the display of sourceURLs to 5 unless expanded
  const categoriesToShow = isExpanded
    ? record.sourceURLs
    : record.sourceURLs?.slice(0, 5) || []

  return (
    <div className={styles.CategoriesBusinessContainer}>
      <h1 className={styles.CategoriesBusinessTitle}>Source URLs</h1>

      <div className={styles.CategoriesBusinessList}>
        {categoriesToShow.length > 0 ? (
          categoriesToShow.map((category, index) => (
            <span key={index} className={styles.CategoriesBusinessItem}>
              {category}
            </span>
          ))
        ) : (
          <span className={styles.NoCategoriesNumbers}>N/A</span>
        )}
      </div>

      {/* Show the expand button only if there are more than 5 sourceURLs */}
      {record.sourceURLs && record.sourceURLs.length > 5 && (
        <button
          className={styles.CategoriesBusinessButton}
          onClick={toggleExpand}
        >
          {isExpanded ? 'Show less' : `Expand all (${record.sourceURLs.length})`}
        </button>
      )}
    </div>
  )
}

export default SourceURLs
